import React from "react";
import profilePic from "../assets/profile.jpg"; // ensure correct image path
import locationIcon from "../assets/location.jpg";

function About() {
  return (
    <div className="section-content about-layout">
      {/* LEFT SECTION - PHOTO + ABOUT */}
      <div className="about-left">
        <img src={profilePic} alt="Parth Suri" className="about-photo" />
        <h2>Parth Suri</h2>
        <div className="about-location">
        <img src={locationIcon} alt="location" className="location-icon" />
        <span>Delhi, India</span>
        </div>
        <h2 className="about-left-title">About Me</h2>
        <p className="about-left-text">
          I'm a data-focused engineer who loves blending{" "}
          <strong>mathematical thinking</strong> with{" "}
          <strong>software engineering</strong>. I enjoy breaking complex
          problems into clean, logical systems and building solutions that
          actually get used.
        </p>
        <p className="about-left-text">
          My work combines <strong>data science</strong>,{" "}
          <strong>quant research</strong>, and <strong>backend development </strong> 
          crafting intelligent tools that turn data into decisions.
        </p>
        {/* RESUME BUTTON */}
        <div className="resume-download">
          <a href="/docs/datascienceresume.pdf"
            className="btn primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Resume</a></div>
      </div>

      {/* RIGHT SECTION - EDUCATION TIMELINE */}
      <div className="about-right">
        <h1>Education</h1>

        <div className="edu-timeline">
          {/* VIT */}
          <div className="edu-item">
            <div className="edu-dot" />
            <div className="edu-card">
              <h3>Bachelor of Technology (B.Tech) in Computer Science and Engineering (Data Science)</h3>
              <p className="edu-institute">Vellore Institute of Technology</p>
              <p className="edu-meta">Sep 2022 - Jun 2026 · Vellore, Tamil Nadu, India</p>
              <p className="edu-desc">
                Specialized in <strong>Data Science</strong> with a focus on{" "}
                <strong>Engineering Mathematics</strong>,{" "}
                <strong>Machine Learning</strong>,{" "}
                <strong>Probability & Statistics</strong>,{" "}
                <strong>Database Systems</strong>, and{" "}
                <strong>Algorithm Design</strong>.  
                Gained experience in <strong>MATLAB</strong>,{" "}
                <strong>MySQL</strong>, <strong>Excel</strong>,{" "}
                <strong>Python</strong>, <strong>C++</strong>, and{" "}
                <strong>Object-Oriented Programming (OOP)</strong>.
              </p>
            </div>
          </div>

          {/* DAV PUBLIC SCHOOL */}
          <div className="edu-item">
            <div className="edu-dot" />
            <div className="edu-card">
              <h3>Higher Secondary Education (CBSE)</h3>
              <p className="edu-institute">
                DAV Public School
              </p>
              <p className="edu-meta">Apr 2020 - Jun 2022 · Sreshtha Vihar, Delhi, India</p>
              <p className="edu-desc">
                Stream: <strong>Science (PCM)</strong> with Computer Science.  
                Built a strong foundation in{" "}
                <strong>Mathematics</strong>, <strong>Physics</strong>, and{" "}
                <strong>Programming Fundamentals</strong> using{" "}
                <strong>Python</strong> and <strong>MySQL</strong>.  
                Developed an early interest in <strong>data systems</strong> and{" "}
                <strong>problem-solving</strong>.
              </p>
            </div>
          </div>

          {/* BAL BHARATI */}
          <div className="edu-item">
            <div className="edu-dot" />
            <div className="edu-card">
              <h3>Secondary Education (CBSE)</h3>
              <p className="edu-institute">Bal Bharati Public School</p>
              <p className="edu-meta">Apr 2008 - Mar 2020 · Ghaziabad, Uttar Pradesh, India</p>
              <p className="edu-desc">
                Completed foundational schooling with exposure to{" "}
                <strong>STEM disciplines</strong> and{" "}
                <strong>digital literacy</strong> through{" "}
                <strong>Microsoft Office Suite</strong> and{" "}
                <strong>introductory programming</strong>.  
                Strengthened analytical reasoning and teamwork through
                academic and project activities.
              </p>
            </div>
          </div>
        </div>
    </div>
    </div>

  );
}

export default About;
